export const selectFilterDropdownValues = (state) => state.filtersReducer.filterDropdownValues;
export const selectSkills = (state) => state.skillsReducer.skills;
